import { Component, Inject, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../services/index';
import { Globals } from "../common/globals";
import { AuthService } from '../auth/authservice.service';
import { ReportsService } from '../reports/reports.service';
import { SsoRedirectService } from '../services/ssoredirect/sso-redirect.service';
import { EnvironmentsService } from 'app/services/enviornment.service';
import { map, mergeMap } from "rxjs/operators";
import { Observable } from "rxjs";
import {ApiService} from 'app/services/api.service';
import { DOCUMENT } from '@angular/common';
import { UserService } from "app/services/user.service";
import { Token } from "@angular/compiler";



@Component({
  selector: 'login',
  styleUrls: ['login.component.scss'],
  templateUrl: 'login.component.html'
})

export class LoginComponent implements OnInit {
  ssoUrl: any;
  refreshed = false;
  model: any = {
    type: "PC_LOGIN"
  };
  returnUrl: string;
  loading: boolean = false;
  isActiveError: string = "";
  errormessage: string = "";
  sessionExpiredError: boolean = false;
  loginTypes = [
    {
      visibleName: "Partner Central",
      type: "PC_LOGIN"
    }
    
  ];

  constructor(private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private authService: AuthService,
    private reportService: ReportsService,
    private globals: Globals,
    private ssoredirectservice: SsoRedirectService, private envService: EnvironmentsService,private apiService: ApiService, @Inject(DOCUMENT) private document: Document, private userService: UserService) {
    this.ssoUrl =  this.envService.config.api;
    globals.woneLoginUrl = this.ssoUrl;
  }

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    
    // Check if redirected due to session expiry
    if (this.route.snapshot.queryParams['error'] === 'session_expired') {
      this.sessionExpiredError = true;
    }
    
      //for emp login 
      this.loading = true;
      this.route.queryParams.pipe(
        map(params => params),
        mergeMap((data: any) => {
          const code = data.code;
          const state = data.state;
          if (state !== this.envService.config.state) {
            return Observable.throw('Wrong state...');
          }
          const redirectUri = window.location.origin + this.envService.config.redirectUri;
          return this.apiService.authenticate(code, this.envService.config.clientCSPId,redirectUri);
      })).subscribe( resp => {
        
        if (!resp || !resp._body) {
          console.error('Invalid response');
          this.isActiveError = 'active';
          this.errormessage = 'Authentication failed. Please try again.';
          this.loading = false;
          return;
        }
        
        try {
          const parsedBody = JSON.parse(resp._body);
          
          const token = (parsedBody.body && parsedBody.body.access_token) || parsedBody.access_token;
          
          if (!token) {
            console.error('No access token in response');
            this.isActiveError = 'active';
            this.errormessage = 'Authentication failed. No access token received.';
            this.loading = false;
            return;
          }
          
          localStorage.setItem('token', token);
          let loggedUrlEmail = this.authService.decodeTokenStr(token)["acct"];
          this.authenticationService.subject.next({ isUserLoggedIn: true, name: loggedUrlEmail });
          this.userService.saveCurrentSession(resp);
          this.router.navigate(['/home']);
        } catch (error) {
          console.error('Error parsing response');
          this.isActiveError = 'active';
          this.errormessage = 'Authentication failed. Invalid response format.';
          this.loading = false;
        }
      }, error => {
        console.error('Authentication error');
        this.isActiveError = 'active';
        this.errormessage = 'Authentication failed. Please try signing in again.';
        this.loading = false;
      })
    }

  login() {
    this.isActiveError = "";
    this.loading = true;
    this.authenticationService.login(this.model.username, this.model.password, this.model.type)
      .subscribe(
        data => {
          this.loading = false;
          localStorage.setItem("token", data.token);
          this.router.navigate(["/"]);
        },
        error => {
          this.isActiveError = "active";
          this.loading = false;
          try{
            this.errormessage = JSON.parse(error._body)["errorMessage"];
          }
          catch(e){
            this.errormessage = "Error authenticating. Please retry ."
            // Error details redacted for security
          }
        });
  }
}

export class AuthenticationResponse {
  access_token: string;
  expires_in: number;
  refresh_token: string
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts